/**
 * Converts a snake_case string to Title Case for display.
 * Replaces underscores with spaces and capitalizes the first letter of each word.
 * e.g. "mandate_id" -> "Mandate Id", "processor_reference" -> "Processor Reference"
 */
export const snakeCaseToTitleCase = (key: string): string =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

/**
 * Loose email format check; the backend does the full validation.
 * e.g. "bob@example.com" -> true, "bob@example" -> false
 */
export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

/**
 * Prefixes a word with a count, adding "s" unless the count is 1.
 * e.g. (1, "member") -> "1 member", (3, "member") -> "3 members"
 */
export const pluralize = (count: number, word: string): string => `${count} ${word}${count === 1 ? '' : 's'}`;
